import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { getTokenInformation } from '../api/routes';
import Loading from './Loading';
import { useDispatch } from 'react-redux';
import { updateTokenInfo } from '../features/tab/tokenInfoSlice';

export default function TokenHandler() {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();

    useEffect(() => {
        setLoading(true)
        getTokenInformation(searchParams.get("q"), (isOk, data) => {
            if (!isOk) {
                setLoading(true)
                return alert(data.message);
            }
            else {
                setLoading(false)
                if (!data) {
                    alert("اطلاعاتی برای مرکز مورد نظر ثبت نشده است!")
                    window.history.go(-1)
                } else {
                    dispatch(updateTokenInfo({ isPacs: data.is_pacs, logo: data.logo, website: data.website, tel: data.TelDep, pacs_ip_report: data.pacs_ip_report, pacs_ip_images: data.pacs_ip_images, api_route: data.api_route, pacs_user_token: data.pacs_user_token, pacs_admin_token: data.pacs_admin_token }))
                }
            }
        })
    }, [])

    return (
        <>
            <Loading loading={loading} />
        </>
    )
}
